import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import { refresh } from 'ionicons/icons';
import { getShoppingCart } from '../utils/functions';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));
        getRequest(data, controller).then(
            (response) => {

                if (data.typeOption == "get_list_registers") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            RegistersDB: response.data,
                            data_pagin_RegistersDB: response.data.data,
                            refresh_list: false,
                            categories_Registers_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            RegistersDB: response.data,
                            refresh_list: false,
                            categories_Registers_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_RegistersDB'));
                    }
                } else if (data.typeOption == "getRegisterData") {
                    dispatch(setData({
                        RegistersData: response.data,
                        refresh_list: false,
                        loading: { Msg: 'Cargando...', isOpen: false },
                    }));
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active,
            list_search_products: [],
        }));

        postRequest_(data, controller).then(
            (response) => {


            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}